import styled from 'styled-components';

export const Svg = styled.svg`
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
`;
